import { render } from "./ZamgRectangleRemove.vue?vue&type=template&id=3f5e2704&ts=true"
import script from "./ZamgRectangleRemove.vue?vue&type=script&lang=ts"
export * from "./ZamgRectangleRemove.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__